module.exports = __webpack_public_path__ + "assets/pdf/I02-en-urban.5715ad1d.pdf";